import type { AppTheme } from '../utils/appTheme';

const BOOKING_URL = 'https://calendly.com/contact-palen/30min';
// Neutral backgrounds let the frame blend into the page without unsupported alpha colors.
const EMBED_COLORS = {
  light: { background_color: 'ffffff', text_color: '1b2938', primary_color: 'b82b25' },
  dark: { background_color: '000000', text_color: 'e2e8f0', primary_color: 'fca5a5' },
} satisfies Record<AppTheme, Record<string, string>>;

export const demoSchedulingService = {
  getExternalUrl(): string {
    return BOOKING_URL;
  },

  getInlineUrl(theme: AppTheme = 'light', hostname = 'palen-adr.eu'): string {
    const url = new URL(BOOKING_URL);
    // Calendly embed options: https://calendly.com/help/how-to-customize-your-embed
    // Direct-frame context: https://community.calendly.com/how-do-i-40/embed-styling-for-iframe-background-color-2214
    const parameters = {
      embed_domain: hostname,
      embed_type: 'Inline',
      hide_event_type_details: '1',
      hide_gdpr_banner: '0',
      ...EMBED_COLORS[theme],
    };
    Object.entries(parameters).forEach(([key, value]) => url.searchParams.set(key, value));
    return url.toString();
  },

  getModalUrl(): string {
    return `${BOOKING_URL}?hide_event_type_details=1&hide_gdpr_banner=1`;
  },
};
